export default __webpack_public_path__ + "static/media/codeweb-logo-full.eed94ee6.svg";